import ImageTool from './tools/image';

export default {
    image: new ImageTool(),
};



// WEBPACK FOOTER //
// ./node_modules/@bigcommerce/stencil-utils/src/tools.js